import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { message } from 'antd'
import { equipmentSelector, updateEquipmentAction, fetchEquipmentByIdAction } from '../../../store/equipment'
import EquipmentFormModal from './EquipmentFormModal'

const messageKey = 'edit_equipment'

const API_URL = process.env.REACT_APP_API_URL

const EditEquipmentModal = (props) => {
  const dispatch = useDispatch()
  const { isFetching } = useSelector(equipmentSelector)

  const { equipmentId, onFinish } = props

  let [equipment, setEquipment] = useState(null)

  const fetchEquipment = useCallback(
    async (id) => {
      const response = await dispatch(fetchEquipmentByIdAction(id)).unwrap()
      setEquipment({
        ...response.data.attributes,
        images: response.data.attributes.images.data?.map((f) => ({
          ...f.attributes,
          fileId: f.id,
          url: `${API_URL}${f.attributes.url}`,
        })),
      })
    },
    [dispatch]
  )

  useEffect(() => {
    if (equipmentId) {
      fetchEquipment(equipmentId)
    }
  }, [equipmentId, fetchEquipment])

  const onFinishAction = useCallback(
    async ({ name, serial_number, issue_year, price, description, images }) => {
      await dispatch(
        updateEquipmentAction({ id: equipmentId, name, serial_number, issue_year, price, description, images })
      ).unwrap()
      message.success({
        key: messageKey,
        content: `Оборудование '${name}' обновлено успешно`,
      })
      onFinish()
    },
    [equipmentId, dispatch]
  )

  const onErrorAction = useCallback(({ name, status, message: errorMessage }) => {
    message.error({
      key: messageKey,
      content: `Ошибка (${name}, статус: ${status}): '${errorMessage}' `,
    })
  }, [])

  return (
    <EquipmentFormModal
      {...props}
      modalTitle="Редактирование оборудования на складе"
      formName="update-equipment"
      submitCaption="Редактировать"
      equipment={equipment}
      isFetching={isFetching}
      onFinish={onFinishAction}
      onError={onErrorAction}
    />
  )
}

export default EditEquipmentModal
